module.exports = __webpack_public_path__ + "img/cocos_1.5a26d9fc.jpg";